<template>
  <div :class="isMobile ? 'events-only' : 'only-list-day has--scroll'">
    <div
      v-if="!surgeryList || !surgeryList.length"
      :class="isMobile ? 'no-events' : 'empty-list-day center'"
    >
      אין אירועים
    </div>
    <!-- mobile -->
    <template v-if="isMobile">
      <div
        v-for="event in surgeryList"
        :key="event.id"
        class="vuecal__event appointmentBlock"
      >
        <surg-list-event :isMobile="isMobile" :event="event" />
      </div>
    </template>
    <!-- desktop -->
    <template v-else>
      <surg-list-event
        v-for="event in surgeryList"
        :key="event.id"
        :isMobile="isMobile"
        :event="event"
      />
    </template>
    <div class="only-print" style="padding-top: 20px;">
      <b class="tx--blue2">
        כמות הניתוחים:
      </b>
      {{ surgeryList && surgeryList.length ? surgeryList.length : 0 }}
    </div>
  </div>
</template>

<script>
import SurgListEvent from "@/components/Dashboard/List/SurgListEvent.vue";

export default {
  name: "SurgeryList",
  components: { SurgListEvent },
  props: {
    surgeryList: { required: true },
    isMobile: { default: false }
  }
};
</script>
